import { ORIGIN_OPTIONS } from "./consts";

export const getOriginLabel = (origin: string | null | undefined) => {
  return ORIGIN_OPTIONS.find((option) => {
    return option.value === origin;
  })?.label;
};
